import { createReducer, on } from '@ngrx/store';
import { avatarDeletion, avatarDeletionFailure, avatarDeletionSuccess, avatarUpdate, avatarUpdateFailure, avatarUpdateSuccess, profileUpdate, profileUpdateFailure, profileUpdateSuccess } from './profile.actions';
import { sharedInitialState } from '../Authentication/auth.models';


export const profileReducer = createReducer(
    //Pushed all reducer actions to authentication.reducer cause prfileReducer is a part of it as well
    sharedInitialState,
);